import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  getEngineCodes,
  getEngineCode,
  createEngineCode,
  editEngineCode,
  deleteEngineCode,
} from "api/engineCodeApi"

export const ENGINE_CODE_QUERY_KEY = "engine-codes"

export const useEngineCodes = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [ENGINE_CODE_QUERY_KEY, params],
    queryFn: () => getEngineCodes(params),
    keepPreviousData: true,
    enabled
  })
}

export const useEngineCode = id => {
  return useQuery({
    queryKey: [ENGINE_CODE_QUERY_KEY, id],
    queryFn: () => getEngineCode(id),
    enabled: !!id,
  })
}

export const useCreateEngineCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createEngineCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CODE_QUERY_KEY])
      }
    },
  })
}

export const useEditEngineCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editEngineCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CODE_QUERY_KEY])
      }
    },
  })
}

export const useDeleteEngineCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteEngineCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([ENGINE_CODE_QUERY_KEY])
      }
    },
  })
}
